import { jsx as _jsx } from "react/jsx-runtime";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo("en-US");
const Component = ({ date }) => {
    return _jsx("span", { children: timeAgo.format(date) });
};
export default Component;
